import { DEFAULT_MODEL } from './defaults';

interface Model {
  id: string;
  name: string;
  shortName: string;
  description: string;
}

export const AVAILABLE_MODELS: Model[] = [
  {
    id: 'gpt-5.2',
    name: 'GPT-5.2',
    shortName: 'GPT-5.2',
    description: 'Latest model with very enhanced capabilities',
  },
  {
    id: 'claude-opus-4-6',
    name: 'Claude Opus 4.6',
    shortName: 'Claude Opus 4.6',
    description: 'Anthropic Claude with advanced capabilities',
  },
  {
    id: 'claude-sonnet-4-6',
    name: 'Claude Sonnet 4.6',
    shortName: 'Claude Sonnet 4.6',
    description: 'Anthropic Claude with long context',
  },
  {
    id: 'databricks-gemini-3-1-pro',
    name: 'Gemini 3.1 Pro served by Databricks',
    shortName: 'Gemini 3.1 Pro',
    description: 'Gemini 3.1 Pro is Google\'s most advanced reasoning Gemini model, capable of solving complex problems.',
  },
];

const AVAILABLE_MODEL_IDS = new Set(AVAILABLE_MODELS.map((model) => model.id));

const MODEL_DISPLAY_NAMES = Object.fromEntries(
  AVAILABLE_MODELS.map((model) => [model.id, model.shortName]),
) as Record<string, string>;

export function normalizeSelectedModel(model?: string): string {
  if (!model || !AVAILABLE_MODEL_IDS.has(model)) {
    return DEFAULT_MODEL;
  }

  return model;
}

export function getSelectableModelDisplayName(model?: string): string {
  const normalizedModel = normalizeSelectedModel(model);
  return MODEL_DISPLAY_NAMES[normalizedModel] || DEFAULT_MODEL;
}

export type { Model };
